// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__hDK2v","col":"styles_col__iLl-6"};